import { render, staticRenderFns } from "./VFatherProAnamANxAP.vue?vue&type=template&id=48b80852"
import script from "./VFatherProAnamANxAP.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamANxAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports